import { render } from "./PwdReverted.vue?vue&type=template&id=c354e802"
import script from "./PwdReverted.vue?vue&type=script&lang=js"
export * from "./PwdReverted.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__